import angular from "angular";
import chatModule from '../chatModule';

function storageService(resources, $log, localStorageService) {
    "ngInject";

    var isChatDataFromLocalStorageEnabled = false;
    var chatDataFromLocalStorageExpirationMS = 10000;

    return {
        chatDataName: {
            getUserConversations: "getUserConversations",
            getConversations: "getConversations",
            getMessages: "getMessages"

        },

        setStorageParams: function (data) {
            isChatDataFromLocalStorageEnabled = data.IsChatDataFromLocalStorageEnabled;
            chatDataFromLocalStorageExpirationMS = data.ChatDataFromLocalStorageExpirationSeconds * 1000;
        },

        getStorageName: function (name, params) {
            var chatDataLSName = resources.chatDataLSNamePrefix + "." + name;
            angular.forEach(params, function (param) {
                chatDataLSName = chatDataLSName + "." + param;
            });
            return chatDataLSName;
        },

        saveChatDataToLocalStorage: function (name, data) {
            if (isChatDataFromLocalStorageEnabled) {
                localStorageService.saveDataByTimeStamp(name, data);
            }
        },

        getChatDataFromLocalStorage: function (name) {
            if (isChatDataFromLocalStorageEnabled) {
                localStorageService.fetchNonExpiredCachedData(name, chatDataFromLocalStorageExpirationMS);
            }
            return null;
        },

        clearLocalStorage: function () {
            var storageData = localStorageService.storage();
            if (storageData) {
                for (var key in storageData) {
                    if (key && key.search(resources.chatDataLSNamePrefix) > -1) {
                        localStorageService.removeLocalStorage(key);
                    }
                }
            }
        }
    }
};

chatModule.factory("storageService", storageService);

export default storageService;